module.exports = __webpack_public_path__ + "static/media/Ornate1_Before.3565b578.jpg";